<section class="resource-questions">
  <ng-container *ngIf="questions$ | async as options ;else skeleton">


    <mat-list *ngIf="options?.length; else noData">
      <mat-list-item role="listitem"
        *ngFor="let option of options;trackBy:trackByFn">

        <div class="d-flex justify-content-between"
          mat-line>
          <span class="overflow-text">
            {{ option.data.question }}
          </span>
          <span *ngIf="!disabled && !viewOnly && option.active">
            <button mat-stroked-button   color="primary"
              (click)="add(option.data)">{{ 'forms.common.add' | translate }}</button>
          </span>
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>

    </mat-list>


  </ng-container>
</section>

<ng-template #noData>
  <div class="pb-4 h-100% text-center">
    <div class=" ">
      <h4>{{ 'ERRORS.NoDataFound' | translate }}</h4>
    </div>
  </div>
</ng-template>

<ng-template #skeleton>
  <div class="p-2">
    <formio-skeleton width="80%"
      styleClass="mb-2"
      height="25px"></formio-skeleton>

    <formio-skeleton width="50%"
      height="30px"
      styleClass="mb-2"></formio-skeleton>
    <formio-skeleton width="90%"
      height="40px"
      styleClass="mb-2"></formio-skeleton>
    <formio-skeleton width="30%"
      styleClass="mb-2"
      height="20px"></formio-skeleton>
    <formio-skeleton styleClass="mb-2"></formio-skeleton>
  </div>
</ng-template>
